"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var Promo_1 = __importDefault(require("./Promo"));
var RandomSlot_1 = __importDefault(require("./RandomSlot"));
var useRandomGame_1 = __importDefault(require("./RandomSlot/useRandomGame"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var PromoBlocks = function (_a) {
    var _b = _a.hasTitle, hasTitle = _b === void 0 ? false : _b, _c = _a.hasTextTitle, hasTextTitle = _c === void 0 ? false : _c, _d = _a.isFullImage, isFullImage = _d === void 0 ? false : _d, _e = _a.randomByBtn, randomByBtn = _e === void 0 ? false : _e;
    var t = (0, next_intl_1.useTranslations)('translation');
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var randomGame = (0, useRandomGame_1.default)();
    var signUpLink = (0, apps_shared_1.useModalLink)(apps_shared_1.POPUP_CONSTANTS.SIGN_UP_MODAL);
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var router = (0, navigation_1.useRouter)();
    var playRandomGame = (0, react_1.useCallback)(function () {
        router.push(isAuth ? generateUrlWithLang("/game/".concat(randomGame === null || randomGame === void 0 ? void 0 : randomGame.slug)) : signUpLink);
    }, [generateUrlWithLang, router, isAuth, randomGame, signUpLink]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.backgroundWrapper },
        hasTitle && (react_1.default.createElement("div", { className: styles_module_scss_1.default.titleWrap },
            react_1.default.createElement("img", { src: "/img/promo-blocks/flash.png", alt: "flash" }),
            react_1.default.createElement("h2", { className: styles_module_scss_1.default.title }, t('timeToGame')),
            react_1.default.createElement("img", { src: "/img/promo-blocks/flash.png", alt: "flash" }))),
        hasTextTitle && react_1.default.createElement("h2", { className: styles_module_scss_1.default.title }, t('timeToGame')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.blockWrapper },
            react_1.default.createElement(Promo_1.default, { isFullImage: isFullImage }),
            !randomByBtn && react_1.default.createElement(RandomSlot_1.default, { playRandomGame: playRandomGame })),
        randomByBtn && (react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", height: "55px", onClick: playRandomGame }, t('randomGame')))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.background })));
};
exports.default = react_1.default.memo(PromoBlocks);
